// extracted by mini-css-extract-plugin
module.exports = {"container":"AspectRatioContainer_container__7z1LH","containerInner":"AspectRatioContainer_containerInner__bkJHb","containerOuter":"AspectRatioContainer_containerOuter__j1Mxt"};